module.exports = {
  login: {
    title: 'Konto anmelden',
    rememberPsd:'Passwort speichern',
    forgetPsd:'Passwort vergessen',
    signIn:'Einloggen',
    signUp:'Registrierung',
    enteraccount:'E-Mail-Adresse/ Mobiltelefonnummer',
    accountnot:'Konto existiert nicht!',
    accountpassword:'Password',
    entercode:'Bitte geben Sie den Bestätigungscode ein',
    ApplyQrCode:'Beantragung des Hangtags',
    ThirdPartyLogin: 'Anmeldung durch dritter Anbieter',
    accountLength:'Der Kontoname hat die maximale Länge von 32 Ziffern erreicht.',
    passwordLength:'Die Passwortlänge hat die maximale Länge von 16 Ziffern erreicht.',
    noAccOrPsd:'Kontokennwort darf nicht leer sein.',
    enterid:'Kennung des produktes',
    scanphone:'Fotos machen und scannen',
    platform:'Dogness platform',
    areaCode:'Land und gebiet',
    agree:'Logging in is agreeing to a',
    privacyStatement:'privacy policy',
    setLoginPsw:'Bitte geben sie den log-code ein und bestätigen sie das passwort',
    pswSimple:'Der code ist zu einfach.'
  },
  btn: {
    text: 'button'
  },
  btmNavBar:{
    device:'Gerät',
    finder:'Hilfe- Suche',
    my:'Mein'
  },
  finder: { //协寻列表
    find: 'Hilfe- Suche',
    filtrateTime: 'Zeit', //时间筛选
    filtrateDis: 'Entfernung', //距离筛选
    noMoreFind:'Keine weiteren Informationen der Hilfe- Suche',
    pullRefresh:'Nach unten ziehen zur Aktualisierung ',
    noComment:'Von ohne kommentare',
    noMoreComment:'Haben alle kommentare gegeben',
    comments:'Jüngsten kommentare',
    enterComment:'Geben sie einen kommentar ein!',
    notAccount:'Bitte loggen sie sich ein, um die kommentare einzulesen'
  },
  device: { //设备列表
    noLogin: 'Sie sind nicht angemeldet. Bitte melden Sie sich an, um das Gerät anzuzeigen',
    myDevice: 'Mein Gerät',
    deviceNull:'Sie haben noch kein Dogness Smart Produkt hinzugefügt',
    goLogin:'Bitte anmelden',
    deviceCode: 'Gerätenummer',
    bindPet: 'Gebundenes Haustier',
    noBindPet: 'Das Gerät ist nicht mit Haustieren gebunden.',
    hint: 'Wenn Sie das Gerät löschen möchten, lösen Sie die Verbindung zum Haustier zuerst auf. ',
    unbind: 'Auflösen',
    delDevice: 'Löschen',
    addNewDevice:'Das neue Gerät hinzufügen',
    nobindDevice:'Kein Dongness Smart Gerät ist gebunden',
    isDelete:'Wollen Sie das Gerät löschen?',
    deleteDevice:'Löschen das Gerät'
  },
  addDevice:{
    scanQRC: 'QR-Code scannen',
    makePhotoSign: 'Klicken sie auf den knopf oben für die kamera, um ein binäres zubehör zu verwenden',
    ifConntRecog: 'Einen versuch, den man nicht erkennt',
    inputQRC: 'QR-Code-Nummer eingeben',
    recogQRC: 'Identifizieren Sie den ausgewählten QR-code',
    reMake: 'Remake',
    chackYourId:'Ihre Geräte-ID wurde als erkannt:',
    bingDev:'Bindung-Geräte',
    cancel:'Abbrechen',
    recogging:'Der QR-Code wird, bitte später identifiziert...',
    conntRecog:'Wenn sie die größe des wahlkreises nicht identifiziert haben, wählen sie die erdanzielerreichung entweder frontal Oder pixel',
    QRCcontent:'Identifizierung der QR-Code-Inhalte',
    sure:'Bestimmen',
    successBind:'Bindung ist es gelungen',
    alreadyBinged:'Das Gerät hat gebunden.',
    notexist:'Das gerät existiert nicht!'
  },
  bindById:{
    inputId:'ID verbindlich Eingabegerät',
    pleaseInput:'Bitte geben Sie das Gerät QR-Code-Nummer',
    sureBind:'Bindung zu bestätigen',
    successBind:'Bestimmen',
    alreadyBinged:'Das Gerät hat gebunden.',
    faileBind:'Der einsatz ist fehlgeschlagen. Geben sie die richtige gerätenummer ein',
    cannotBind:'Ein gerät, das nicht aufhängt, kann nicht entführt werden'
  },
  my: {
    myAccount: "Meine Benutzer ",
    myPet: "Mein Haustier ",
    masterInfo: 'Informationen des Besitzers',
    myFinder: 'Meine Hilfe- Suche',
    changePsd: 'Passwort ändern',
    onlineService: 'Online-Kundenservice',
    FAQ: 'Häufig gestellte Fragen',
    exit: 'Abmelden',
    isExit:'Ob gedruckt',
    myname:'. Namen'
  },
  searchmessage:{
    title:'titel',
    describe:'Des gemeinsamen koordinierungs - zu profile',
    petphone:'Haustiere fotos'
  },
  mysearch: {
    status: 'Status',
    finding:'Auf der Suche nach',
    finded:'Gefunden',
    closed:'Geschlossen',
    time: 'Zeit',
    publishFind: 'Veröffentlichung der Hilfe- Suche ',
    clickToCheck: 'Klicken Sie auf Abfragescan-Datensatz',
    losePlace: 'Verloren gegangener Ort ',
    loseTime: 'Verloren gegangener Zeitpunkt',
    stopfind:'Derzeit existiert kein gesuchtes Haustier ',
    nofindpet:'Derzeit existiert kein gefundenes Haustier ',
    nostoppet:'Derzeit ist kein Suche abgeschlossenes Haustier '
  },
  changefindpetinfo: {
    changefind: 'Änderung der Hilfe- Suche',
    findPet: 'Hilfe- Suche nach Haustier',
    clickToChangePlace:'Klicken Sie unten, um den Standort zu wechseln',
    petPhotos: 'Haustier Fotos (maximal 3 Stücke)',
    publicRelation: 'Kontakt Veröffentlichung ',
    findStatus:'Zustand der Hilfe- Suche',
    commit:'Einreichen',
    more:'Mehrfachauswahl',
    select:'Bitte wählen',
    enterTitle:'Bitte geben Sie einen Titel weniger als 20 Wörter ein',
    describe:'Bitte beschreiben sie die liebesgeschichte und ihren abgang',
    change:'System Modifikation, bitte warten',
    failure:'Anfrage fehlgeschlagen'
  },
  masterInfo:{
    masterInfo:'Informationen des Besitzers',
    nickName:'Spitzname',
    sex:'Geschlecht',
    email:'Mail Adresse',
    phone:'Tel.: Nummer',
    add:'Kontaktadresse'
  },
  changepassword:{
    oldPsd:'Bitte geben Sie das alte Passwort ein',
    newPsd:'Bitte geben Sie das neue Passwort ein',
    againPsd:'Bitte geben Sie das neue Passwort erneut ein',
    trueChange:'Bestätigung der Änderung',
    notPsd:'Das Passwort darf nicht leer sein',
    falsePsd:'Falsches Passwort',
    lessPsd:'Das Passwort darf nicht weniger als 6 Ziffern sein',
    notSamePsd:'Inkonsistentes Passwort'
  },
  petDetails:{
    find:'Hilfe- Suche',
    findInfo:'Details der Hilfe- Suche',
    petintro:'Haustier Vorstellung',
    relationPer:'Kontaktperson',
    relationWay:'Kontaktinformation',
    relHelp:'Zusammenhängende Hilfe- Suche',
    share:'Freigabe für',
    cancelshare:'Freigabe abzubrechen',
    wx:'Der WeChat- Browser.',
    lost:'verloren gegangener Ort'
  },
  addpet:{
    cat:'katze',
    dog:'hund',
    addpet:"Haustier hinzufügen",
    setPetPortrait:'Portrait einstellen',
    petName:'Haustier Spitzname ',
    petType:'Haustier Rasse',
    color:'Haustier Farbe',
    sex:'Haustier Geschlecht',
    weight:'Haustier Gewicht',
    height:'Haustier Größe',
    birthday:'Haustier Geburtstag',
    character:'Haustier Charakter',
    trueAdd:'Bestätigen Sie das Hinzufügen',
    flag2:'Es gilt nur für Buchstabe, Zahlen, Unterstriche, Minuszeichen',
    notpetName:'Haustier Name ist nicht ausgefüllt',
    enterchinese:'Bitte geben sie bitte chinesisch Oder englisch ein',
    notpetType:'Haustierrasse ist nicht ausgefüllt',
    notpetColor:'Die Haustierfarbe ist nicht ausgefüllt',
    notpetSex:'Haustiergeschlecht ist nicht ausgewählt',
    not:'Nur eine zahl.',
    enterweight:'Gewicht eingeben',
    enterheight:'Größe eingeben',
    notWeight:'Gewicht des Haustieres ist nicht ausgefüllt',
    notHeight:'Größe des Haustieres ist nicht ausgefüllt',
    selectData:'Datum auswählen',
    selectSex:'Wähle das Geschlecht',
    notBirthday:'Geburtsdatum ist nicht ausgewählt',
    entercharacter:'Charakter eingeben',
    notcharacter:'Persönlichkeit des Haustieres ist nicht ausgefüllt',
    entername:'Namen eingeben',
    enterType:'Haustierrasse eingeben',
    enterColor:'Farbe eingeben',
    have:'nicht leer zu sein',
    savechage:'Änderungen zu speichern',
    petNews:'Informationen zum Haustier',
    deletePet:'Haustier zu löschen',
    report:'Veröffentlichung der Hilfe- Suche',
    submiting:'Einreichen, Bitte warten Sie'
  },
  mapinfo:{
    sure:'Bestimmen'
  },
  privacyStatement:{
    appPrivacy:'App-Datenschutzerklärung',
    addEnglish:'',
    addEnglish1:'',
    phead:'Dogness  achtet strikt auf den Schutz Ihrer Privatsphäre. Manchmal benötigen wir bestimmte Informationen, um Ihnen die gewünschten Dienste zur Verfügung zu stellen. Diese Datenschutzerklärung erläutert die Erfassung und Verwendung der Daten von Dogness. Diese Datenschutzerklärung gilt für alle zugehörigen Dienste der Dogness.',
    one:'Sammlung Ihrer persönlichen Daten',
    addEnglish2:'',
    onecontent:'Wenn wir Informationen benötigen, die Sie identifizieren können (persönliche Informationen) oder Informationen, die  zum Kontakt mit Ihnen  führen können, werden wir Sie um Ihre Einwilligung bitten.',
    two:'Bewahren Ihre persönlichen Daten',
    twocontent:'Dogness gibt Ihre persönlichen Daten offen, wenn die gesetzlich vorgeschrieben sind oder in Übereinstimmung mit den entsprechenden Servicebedingungen von Dogness, die Softwarelizenzvereinbart oder aus gutem Grund anzunehmen sind. Die Bedingungen sind erforderlich: (a) die ausdrücklichen gesetzlichen Anforderungen zu erfüllen oder die anwendbaren gesetzlichen Verfahren für die Anwendung von Dogness App einzuhalten; (b) die einschlägigen Servicebestimmungen von Dogness  und die Vereinbarung über die Verwendung der Software einzuhalten; (c) Schutz der Rechte oder des Eigentums von Dogness (d) Schutz der persönlichen Sicherheit der Benutzer und Mitarbeiter, sowie Produkten und Dienstleistungen von Dogness oder der Sicherheit der Öffentlichkeit.',
    twocontent1:'Dogness gibt diese Informationen nicht ohne Erlaubnis an Dritte weiter, sofern in dieser Erklärung nichts anderes angegeben ist.',
    three:'Die Sicherheit Ihrer persönlichen Daten',
    threecontent:'Die Sicherheit Ihrer persönlichen Daten werden sehr strikt bei uns geschützt. Wir verwenden eine Reihe von Sicherheits- Technologien, - Verfahren, um Ihre persönlichen Daten vor unbefugtem Zugriff, Verwendung oder Weitergabe zu schützen. Wenn Sie Fragen an unserem Datenschutz haben, senden Sie uns bitte eine E-Mail an service@dognesstech.com',
    
    addEnglish3:'',
    addEnglish4:'',
    addEnglish5:'',
    addEnglish6:'',
    addEnglish7:'',
    addEnglish8:'',
    addEnglish9:'',
    addEnglish10:'',
    addEnglish11:'',
    addEnglish12:'',
    addEnglish13:'',
    addEnglish14:'',
    addEnglish15:'',
    addEnglish16:'',
    addEnglish17:'',
    addEnglish18:'',
    addEnglish19:'',
    addEnglish20:'',
    addEnglish21:'',
    addEnglish22:'',
    addEnglish23:'',
    addEnglish24:'',
    addEnglish25:'',
    addEnglish26:'',
    addEnglish27:'',
    addEnglish28:'',
    addEnglish29:'',
    addEnglish30:'',
    addEnglish31:'',
    addEnglish32:'',
    addEnglish33:'',
    addEnglish34:'',
    addEnglish35:'',
    addEnglish36:'',
    addEnglish37:'',
    addEnglish38:'',
    
    four:'Straffreiheitserklärung',
    fourcontent:' Dogness übernimmt keine rechtliche Verantwortung für die folgenden Angelegenheiten:',
    fourcontent1:'Durchsickern persönlicher Informationen durch Dogness;',
    fourcontent2:'非因《多尼斯》原因导致的个人信息的泄漏；',
    fourcontent3:'Streitigkeiten, die sich aus der Verwendung Ihrer persönlichen Daten durch Dritte gemäß den in den verschiedenen Servicebedingungen und Erklärungen von Dogness festgelegt sind;',
    fourcontent4:'Jegliche vorübergehende Unterbrechung von Diensten aufgrund von Hacking, Computerviren oder staatlichen Vorschriften;',
    fourcontent5:'Alle Folgen, die durch höhere Gewalt verursacht wurden;',
    fourcontent6:'Die in Dogness verschiedenen Nutzungsbedingungen erklärten Straffreiheiten.',
    
    addEnglish39:'',
    addEnglish40:'',
    addEnglish41:'',
    addEnglish42:'',
    addEnglish43:'',
    addEnglish44:'',
    addEnglish45:'',
    addEnglish46:'',
    addEnglish47:'',
    addEnglish48:'',
    addEnglish49:'',
    addEnglish50:'',
    addEnglish51:'',
    addEnglish52:'',
    
    five:'Überarbeitung der Datenschutzerklärung:',
    fivecontent:'Diese Datenschutzerklärung wird bei Bedarf überarbeitet. Wir empfehlen Benutzern, die aktuellen Datenschutzbestimmungen der Nutzungsbedingungen regelmäßig zu überprüfen. Wenn zukünftige Bestimmungen aktualisiert werden, werden wir den Benutzer nicht unverzüglich darauf hinweisen und auch werden nicht rückwirkend auf die vorherigen Situationen angewendet. Die Art und Weise, wie wir mit den zuvor gesammelten Daten umgehen, wird nicht geändert.',
    fivecontent1:'Kontakt：service@dognesstech.com',

    addEnglish53:'',
    addEnglish54:''
  },
  userInformation:{
    changeImg:'Klicken Sie auf das Portrait, um das zu löschen oder wechseln',
    enterusername:'Spitzname Eingabe',
    username:'Spitzname',
    phonenumber:'Mobiltelefon Nummer',
    email:'Mail Adresse',
    savechage:'Änderung zu speichern'
  },
  //sharon
  complete:{
    finishregister:'Herzlichen Glückwunsch zur  Registrierung',
    gologin:'Melde sich umgehend an!'
  },
  emailproving:{
    register:'Konto Registrierung',
    lastStep:'Einen Schritt bis zum Schluss der Registrierung',
    textone:'Wir haben eine Aktivierungs- E-Mail an Ihre E-Mail-Adresse gesendet，',
    texttwo:'Bitte klicken Sie auf den Link in der E-Mail, um die Registrierung abzuschließen!',
    resend:'Erhalten keine E-Mail, klicken auf Senden erneut！',
    ActivateAccount:'Geben die E-Mail ein und aktivieren das Konto.'
  },
  forgetpassword:{
    resetpassword:'Zurücksetzen das Passwort ',
    resetpasswordphone:'Zurücksetzen das Mobiltelefon Passwort ',
    resetpasswordemail:'Zurücksetzen das E-Mail Passwort ',
    setpassword:'设置密码',
    //手机在重置密码
    EnterPhone:'Bitte geben Ihre Mobiltelefonnummer ein',
    FalsePhone:'Das Format der Mobiltelefonnummer ist fehlerhaft ',
    NoPhone:'Mobiltelefonnummer ist nicht registriert',
    NotPhone:'Mobiltelefonnummer darf nicht leer sein',
    NotCode:'Der Bestätigungscode darf nicht leer sein!',
    NoMatch:'Der Bestätigungscode ist fehlerhaft!',
    next:'Nächster Schritt',
    HadAccount:'Ist Konto vorhanden, melden sich direkt ein.',
    sendcode:'Bestätigungscode wird gesendet',
    sendcode2:'Senden',
    sendContent2:'Bitte geben sie die kommentare ein',
    verify:'Klicken auf die Bestätigung',
    resend:'Senden erneut',
    notresend:'Eine SMS wiederholt sich nicht',
    //邮箱在重置密码
    EnterEmail:'Geben E-Mail-Adresse ein',
    FalseEmail:'E-Mail-Adresse ist im falschen Format ',
    NoEmail:'E-Mail-Adresse ist nicht registriert',
    NotEmail:'E-Mail-Adresse darf nicht leer sein!',
    submit:'Einreichen',
    findemail:'Passwort wird durch E-Mail-Adresse abgerufen?',
    finish:'Vollenden',
    authcodeerror:'Bestätigungscode ist fehlerhaft',
    authcodeemail:'Bestätige per E-Mail',
    notemail:'E-Mail-Adresse ist nicht ausgefüllt',
    findphone:'Passwort wird durch Mobiltelefonnummer abgerufen?'
  },
  loginswiper:{
    goregister:'Registrieren umgehend'
  },
  mynews:{
    masternews:'Informationen des Besitzers',
    mastername:'Spitzname',
    mastersex:'Geschlecht',
    masteremail:'Mail Adresse',
    masterphone:'Tel.: Nummer',
    masteradr:'Kontaktadresse'
  },
  mynewsedit:{
    EditMasterNews:'Eigentümerinformation bearbeiten',
    setImg:'Portrait einstellen',
    EnterMastername:'Spitzname Eingabe',
    ChoiceSex:'Wähle das Geschlecht',
    EnterMasterphone:'Geben die Kontaktnummer ein',
    EnterMasteradr:'Geben die Kontaktadresse ein',
    finish:'Vollenden',
    boy:'Männlich',
    girl:'Weiblich',
    failure:'Upload ist fehlgeschlagen!'
  },
  register:{
    registerphone:'Registrierung durch Mobiltelefonnummer',
    registeremail:'Registrierung durch E-Mail-Adresse',
    //手机注册
    registeredphone:'Die Mobiltelefonnummer wurde registriert',
    //邮箱注册
    registeredemail:'Die E-Mail-Adresse wurde registriert',
    enterPsd:'Geben Passwort ein',
    againEnterPsd:'Geben Passwort erneut ein',
    notAgainPsd:'Das Passwort darf nicht leer sein'
  },
  registerfalse:{
    failurelink:'Link ist abgelaufen'
  },
  resetemailproving:{
    lastone:'Wir haben eine E-Mail erfolgreich an Ihre E-Mail-Adresse gesendet:',
    lasttwo:'Befolgen Sie die Anweisungen, um Ihr Passwort zurückzusetzen und die neue Nummer gut zu bewahren！',
    resetPsdEmail:'Das Passwort wird durch E-Mail Zurückgesetzt '
  },
  resetsuccess:{
    changesuccess:'Die Modifikation ist erfolgt'
  },
  //Sharon2018-11-13
  findPetInfo:{
    bound:'Das Gerät ist bereits gebunden',
    enterplatform:'Treten auf Plattform ein'
  },
  qrFindError:{
    deviceError:'Ich kann das gerät nicht identifizieren, ',
    toPlat:'wenden bitte den Kundendienst an'
  },
  releaseSearch:{
    report:'Veröffentlichung der Hilfe- Suche ',
    title:'Bitte geben Sie einen Titel weniger als 20 Wörter ein',
    nottitle:'Titel ist nicht ausgefüllt',
    decription:'Bitte beschreiben Sie die Anforderungen so viele wie möglich',
    notneed:'Nachfrage ist nicht gefüllt',
    losttime:'Verloren gegangener Zeitpunkt',
    choicetime:'Datum auswählen',
    nottime:'Zeitpunkt ist nicht ausgewählt',
    lostadr:'Verloren gegangener Ort (Klicken Sie unten, um den Standort zu wechseln)',
    choicepet:'Auswahl eines Haustiers',
    petImg:'Haustier Fotos (maximal 3 Stücke)',
    opencontact:'Kontakt Veröffentlichung ',
    choice:'Bitte wählen',
    notcontact:'Keine die Kontaktmöglichkeit, bitte ausfüllen',
  },
  connectDevice:{
    accessnetwork:'Verbinden Dogness Smart Gerät mit Netzwerk ',
    configuration:'Mit ca.15 cm Abstand zu QR- Codes auf APP erkennt Kamera des Smart Gerätes es leichter.'
  },
  createQrCode:{
    wifiname:'Geben Sie den ausgewählten WLAN- Namen ein',
    wifipassword:'Geben Sie das WLAN- Passwort ein',
    QrCode:'QR- Code Generierung'
  },
  deviceManage:{
    proName:'Produktname',
    proType:'Produkttyp',
    proNum:'Produktnummer',
    boundpet:'Gebundes Haustier',
    noboundpet:'Ungebundenes Haustier',
    nopet:'Kein Haustier wird hinzugefügt',
    reportfindnews:'Veröffentlichung der der Hilfe- Suchinformation',
    unbind:'Gerät wird gelöst',
    failure:'Fehler'
  },
  binddevice:{
    boundDevice:'Binden das Gerät:',
    clickAddDevice:'Klicken darauf, um Gerät hinzufügen'
  },
  changepet:{
    name:'小小柴',
    surebind:'Bestimmung der Bindung '
  },
  choosePet:{
    mycute:'Mein süßes Haustier',
    choicecute:'Wähle ein süßes Haustier aus'
  },
  //提示框
  prompt:{
    noactivationemail:'Benutzerkonto ist unaktiviert! Das E- Mail mit Aktivierungslink wird erneut gesendet, aktiveren das Konto！',
    messageerror:'Falsche Kontoname oder Passwort',
    loginswiperError:'Benutzername oder Passwort ist falsch eingegeben',
    notapply:'Nicht zur Verfügung gestellt',
    nocontact:'Keine Kontaktmöglichkeit',
    openemail:'Veröffentlichung der E-Mail-Adresse',
    openphone:'Veröffentlichung der Mobiltelefonnummer ',
    openall:'Veröffentlichung der E-Mail-Adresse und Mobiltelefonnummer',
    notChoicePet:'Kein Haustier ist ausgewählt',
    notChoiceConcact:'Offene kontaktdaten sind unoptionen',
    notChoiceImg:'Lebensfotos des Haustiers sind nicht ausgewählt',
    found:'Die Hilfe-Suchinformation Ihres Haustiers ist bereits veröffentlicht',
    notdevice:'Das Haustier ist nicht an das Gerät gebunden',
    scan:'Bitte verwenden Sie den QR- Code eines Drittanbieters',
    scanQrCode:'Richten Sie den QR- Code an der Geräte- Kamera aus',
    bindpetsuccess:'Haustier ist erfolgreich gebunden!',
    removedevice:'Möchten Sie das Gerät wirklich lösen?',
    cancelchange:'Wird die Modifikation aufgegeben?',
    delete:'Dadurch wird die Datei dauerhaft gelöscht, fährt es fort?',
    promptcancel:'Hinweise',
    remove:'Auflösen',
    sure:'Bestimmen',
    cancel:'Abbrechen',
    cancelbind:'Erfolgreich gelöst',
    deletesuccess:'Erfolgreich gelöscht',
    findingpet:'Das Haustier wird nachgesucht!',
    notcancel:'Entbündelung wird aufgegeben',
    feeder:'Dogness Smart Feeder',
    bluetooth:'Bluetooth Schrittzähler',
    robot:'Dogness Smart Roboter',
    QrCode:'Dogness Anhänger der Hilfe- Suche',
    necklace:'Dogness Smart Halsband',
    mianbaoji:'Dogness Mini Smart Roboter',
    toushiqi:'Dogness kleiner Smart Feeder mit Kamera',
    sending:'E-Mail wird gesendet, bitte warten！',
    boy:'Junge',
    girl:'Mädchen',
    notpetimg:'Kein Porträt des Haustiers wird hinzugefügt',
    againlogin:'Kontoanmeldung ist abgelaufen, melden Sie sich erneut an',
    addfailure:'Die Information ist nicht komplett, die Hinzufügung ist fehlgeschlagen!',
    nopetlifepic:'Lebensfotos des Haustiers dürfen nicht leer sein',
    cantdelete:'Das Haustier wird nachgesucht oder das Gerät ist nicht gelöst, so das Gerät nicht gelöscht werden kann.',
    canceldelete:'Löschung bricht ab',
    ycanceldelete:'Lösung ist abgebrochen',
    choosePetone:'Während die suche nach einem haustier läuft, können sie das nicht einfach tun',
    choosePettwo:'Die Auswahl eines Haustieres ist fehlgeschlagen',
    header:'Zeitüberschreitung, bitte melden Sie sich ins Konto erneut an',
    slider:'Soll das Haustier losgebunden werden? ',
    yslider:'Haustier wird ungebunden',
    finding:'Das aktuelle Haustier wird nachgesucht',
    nodevice:'Das Gerät existiert nicht, wenden Sie sich an den Kundendienst',
    bindfailure:'Die Bindung ist fehlgeschlagen, das Gerät wurde von einem anderen Benutzer angemeldet.',
    contactkf:'Systemfehler, bitte wenden Sie sich an den Kundendienst',
    noscan:'Keiner Scannen- Report',
    noApply:'An ihrem browser ist kein interesse an der weitergabe dieses typs!',
    showTimes:'Wie oft wurde dieses gerät eingescannt'
  },
  countries:{
    china:'VR. China',
    hongkong:'Hongkong, VR. China',
    macau:'Macau, VR. China',
    taiwan:'Taiwan, VR. China',
    America:'Vereinigte Staaten',
    Germany:'Deutschland',
    Japan:'Japan',
    Albania: '阿尔巴尼亚',
    Algeria: '阿尔及利亚',
    Afghanistan: '阿富汗',
    Argentina: '阿根廷',
    UnitedArabemirates: '阿拉伯联合酋长国',
    Aruba: '阿鲁巴',

    Oman:'阿曼',
    azerbaijan:'阿塞拜疆',
    Egypt:'埃及',
    Ethiopia:'埃塞俄比亚',
    Ireland:'爱尔兰',
    Estonia:'爱沙尼亚',
    Andorra:'安道尔',
    Angola:'安哥拉',
    anguilla:'安圭拉',
    AntiguaAndBarbuda:'安提瓜和巴布达',
    Austria:'奥地利',
    Australia:'澳大利亚',
    Barbados:'巴巴多斯',
    PapuaNewGuinea:'巴布亚新几内亚',
    Bahamas:'巴哈马',
    Pakistan:'巴基斯坦',
    Paraguay:'巴拉圭',
    Palestine:'巴勒斯坦',
    bahrain:'巴林',
    panama:'巴拿马',
    Brazil:'巴西',
    belarus:'白俄罗斯',
    Bermuda:'百慕大',
    Bulgaria:'保加利亚',
    NorthKorea:'北朝鲜',
    NorthernMarianaIslands:'北马里亚纳群岛',
    BacNinh:'北宁',
    Belgium:'比利时',
    Iceland:'冰岛',
    PuertoRico:'波多黎各',
    Poland:'波兰',
    BosniaAndHerzegovina:'波斯尼亚和黑塞哥维那',
    Bolivia:'玻利维亚',
    Belize:'伯利兹',
    BozWana:'博兹瓦纳',
    Bhutan:'不丹',
    BurkinaFaso:'布基纳法索',
    Burundi:'布隆迪',
    EquatorialGuinea:'赤道几内亚',
    Denmark:'丹麦',
    EastTimor:'东帝汶',
    Togo:'多哥',
    Dominica:'多米尼加',
    DominicanRepublic:'多明尼加共和国',
    Russia:'俄国',
    Ecuador:'厄瓜多尔',
    eritrea:'厄立特里亚',
    France:'法国',
    TheFaroeIslands:'法罗群岛',
    FrenchPolynesia:'法属波利尼西亚',
    Vatican:'梵蒂冈',
    ThePhilippines:'菲律宾',
    Fiji:'斐济',
    Finland:"芬兰",
    CapeVerde:'佛得角',
    Franks:'佛兰克群岛',
    Gambia:'冈比亚',
    Congo:'刚果民主共和国',
    Colombia:'哥伦比亚',
    CostaRica:'哥斯达黎加',
    grenada:'格林纳达',
    Greenland:'格陵兰',
    Georgia:'格鲁吉亚',
    Cuba:'古巴',
    Guam:'关岛',
    Guyana:'圭亚那',
    kazakhstan:'哈萨克斯坦',
    Haiti:'海地',
    Korea:'韩国',
    Netherlands:'荷兰',
    NetherlandsAntilles:'荷属安的列斯',
    Montenegro:'黑山',
    Honduras:'洪都拉斯',
    Kiribati:'基里巴斯',
    djibouti:'吉布提',
    kyrgyzstan:'吉尔吉斯斯坦',
    guinea:'几内亚',
    Canada:'加拿大',
    Ghana:'加纳',
    Gabon:'加蓬',
    Cambodia:'柬埔寨',
    CzechRepublic:'捷克共和国',
    Zimbabwe:'津巴布韦',
    Cameroon:'喀麦隆',
    Qatar:'卡塔尔',
    CaymanIslands:'开曼群岛',
    Comorin:'科摩罗',
    Kuwait:'科威特',
    Croatia:'克罗地亚',
    Kenya:'肯尼亚',
    cookIslands:'库克群岛',
    Latvia:'拉脱维亚',
    Lesotho:'莱索托',
    Laos:'老挝',
    Lithuania:'立陶宛',
    Liberia:'利比里亚',
    Libya:'利比亚',
    Liechtenstein:'列支敦士登',
    reunion:'留尼汪',
    Luxembourg:'卢森堡',
    Rwanda:'卢旺达',
    Romania:'罗马尼亚',
    Madagascar:'马达加斯加',
    Maldives:'马尔代夫',
    Malta:'马耳他',
    Malawi:'马拉维',
    Malaysia:'马来西亚',
    Macedonia:'马其顿',
    MarshallIslands:'马绍尔群岛',
    Mauritius:'毛里求斯',
    Mauritania:"毛里塔尼亚",
    AmericanSamoa:'美属萨摩亚',
    Mongolia:'蒙古',
    Montserrat:'蒙特塞拉特',
    Bangladesh:'孟加拉国',
    Peru:'秘鲁',
    Micronesia:'密克罗尼西亚',
    Burma:'缅甸',
    Moldova:'摩尔多瓦',
    Monaco:'摩纳哥',
    Mozambique:'莫桑比克',
    Mexico:'墨西哥',
    Namibia:'纳米比亚',
    SouthAfrica:'南非',
    SouthSudan:'南苏丹',
    Nauru:'瑙鲁',
    Nicaragua:'尼加拉瓜',
    Nepal:'尼泊尔',
    Niger:'尼日尔',
    Nigeria:'尼日利亚',
    niue:'纽埃',
    Norway:'挪威',
    Palau:'帕劳',
    Portugal:'葡萄牙',
    Sweden:'瑞典',
    Switzerland:'瑞士',
    Salvador:'萨尔瓦多',
    Samoa:'萨摩亚',
    Serbia:'塞尔维亚',
    SierraLeone:'塞拉利昂',
    Senegal:'塞内加尔',
    Cyprus:'塞浦路斯',
    Seychelles:'塞舌尔',
    SaudiArabia:'沙特阿拉伯',
    SaoTomeandPrincipe:'圣多美和普林西比',
    SaintHelena:'圣赫勒拿',
    SaintKittsAndNevis:'圣基茨和尼维斯',
    SaintLucia:'圣卢西亚',
    SanMarino:'圣马力诺',
    SaintPierreandMiquelon :'圣皮埃尔和密克隆',
    SriLanka:'斯里兰卡',
    Slovakia:'斯洛伐克',
    Slovenia:'斯洛文尼亚',
    Swaziland:'斯威士兰',
    Sudan:'苏丹',
    Surinam:'苏里南',
    SolomonIslands:'所罗门群岛',
    Tajikistan:'塔吉克斯坦',
    Thailand:'泰国',
    Tanzania:'坦桑尼亚',
    Tonga:'汤加',
    Tunisia:'突尼斯',
    Tuvalu:'图瓦卢',
    Turkey:'土耳其',
    Turkmenistan:'土库曼斯坦',
    Tokelau:'托克劳',
    Vanuatu:'瓦努阿图',
    Guatemala:'危地马拉',
    Venezuela:'委内瑞拉',
    Brunei:'文莱',
    Uganda:'乌干达',
    Ukraine:'乌克兰',
    Uruguay:'乌拉圭',
    Uzbekistan:'乌兹别克斯坦',
    Spain:'西班牙',
    WesternSahara:'西撒哈拉',
    Greek:'希腊',
    Singapore:'新加坡',
    NewCaledonia:'新喀里多尼亚',
    NewZealand:'新西兰',
    Hungary:'匈牙利',
    Syria:'叙利亚',
    Jamaica:'牙买加',
    Armenia:'亚美尼亚',
    Yemen:'也门',
    Iraq:'伊拉克',
    Iran:'伊朗',
    Israel:'以色列',
    Italy:'意大利',
    India:'印度',
    Indonesia:'印度尼西亚',
    England:'英国',
    BVI:'英属维尔京群岛',
    BIOT:'英属印度洋领地',
    Jordan:'约旦',
    Vietnam:'越南',
    Zambia:'赞比亚',
    Chad:'乍得',
    Gibraltar:'直布罗陀',
    Chile:'智利',
    CentralAfricanRepublic:'中非共和国'
  }

}


// WEBPACK FOOTER //
// ./src/i18n/langs/de.js